import { render, staticRenderFns } from "./ProductPopUpModal.vue?vue&type=template&id=0323a8be&"
import script from "./ProductPopUpModal.ts?vue&type=script&lang=ts&"
export * from "./ProductPopUpModal.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports